module.exports = __webpack_public_path__ + "assets/img/dpglq.a9fcea5c.png";